/* globals jQuery */

import lazyLoad from "./_lazyLoad";
import homeNav from "./_home-nav";
import navScroll from "./_navScroll";
import featuredSlider from "./components/_featured-slider";
import popupContent from "./_popupContent";

import "./_mobileNav";
import "./components/_accordion";
import "./components/_search-dropdown";

function init() {
  jQuery('input[type="submit"]').each((i, e) => {
    let attrStr = "",
      text = "";
    jQuery.each(e.attributes, function(i, elem) {
      if ("value" === elem.name) text = elem.value;
      else attrStr += " " + elem.name + '="' + elem.value + '"';
    });
    jQuery(e).replaceWith("<button" + attrStr + ">" + text + "</button>");
  });

  lazyLoad();
  homeNav();
  navScroll();
  featuredSlider();
  popupContent();
}

init();

AOS.init({
  offset: 100,
  duration: 600,
  easing: "ease-in-sine",
  delay: 50,
  once: true
});
